import { createRouter, createWebHistory } from 'vue-router';
import MapView from '../modules/map/views/MapView.vue';

const routes = [
  {
    path: '/',
    name: 'MapView',
    component: MapView,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
